export const SAME_LOWER_HIERARCHY_DATA_REQUEST = 'SAME_LOWER_HIERARCHY_DATA_REQUEST';
export const SAME_LOWER_HIERARCHY_DATA_SUCCESS = 'SAME_LOWER_HIERARCHY_DATA_SUCCESS';
export const SAME_LOWER_HIERARCHY_DATA_FAIL = 'SAME_LOWER_HIERARCHY_DATA_FAIL';

